import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import "dayjs/locale/en";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

type Language = "zh-cn" | "en";

interface DateFormat {
  yesterday: string;
  sameYear: string;
  differentYear: string;
}

const DATE_FORMATS: Record<Language, DateFormat> = {
  "zh-cn": {
    yesterday: "昨天 HH:mm",
    sameYear: "MM-DD HH:mm",
    differentYear: "YYYY-MM-DD",
  },
  en: {
    yesterday: "[Yesterday] HH:mm",
    sameYear: "MMM D, HH:mm",
    differentYear: "MMM D, YYYY",
  },
};

const formatMessageDateByDayJs = (
  timestamp: number,
  lang: Language = "zh-cn"
): string => {
  dayjs.locale(lang);

  const date = dayjs(timestamp * 1000);
  const now = dayjs();
  const diffDays = now.startOf("day").diff(date.startOf("day"), "day");
  const format = DATE_FORMATS[lang];

  if (diffDays === 0) return date.fromNow();
  if (diffDays === 1) return date.format(format.yesterday);
  if (date.year() === now.year()) return date.format(format.sameYear);
  return date.format(format.differentYear);
};

export { formatMessageDateByDayJs, type Language };
